import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckMark = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 10,
	viewBox: "0 0 12 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.13057 7.26043L2.10641 5.23626C1.87891 5.00876 1.51141 5.00876 1.28391 5.23626C1.05641 5.46376 1.05641 5.83126 1.28391 6.05876L3.72224 8.4971C3.94974 8.7246 4.31724 8.7246 4.54474 8.4971L10.7164 2.32543C10.9439 2.09793 10.9439 1.73043 10.7164 1.50293C10.4889 1.27543 10.1214 1.27543 9.89391 1.50293L4.13057 7.26043Z",
		fill: "#3C59F6",
		stroke: "#3C59F6"
	})
});
export default SvgCheckMark;
